import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Tabs,
  Tab,
  TextField,
  Button,
  CardMedia,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  IconButton,
  FormHelperText,
  Typography,
  Grid,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import { Customer } from "../../types/General";
import React, { ChangeEvent, useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import CompanyDocumentation from "../../features/manageCustomers/CustomerDocs";
import { useLazyGetCategoryQuery } from "../../services/category";
import { showError, showToast } from "../../constants/toasts";
import {
  useAddCustomerMutation,
  useLazyGetCustomerByIdQuery,
  useUpdateCustomerMutation,
} from "../../services/customer";
import PhoneInput from "react-phone-input-2";
import { UploadMedia } from "../../utils/mediaUpload";
import { ROLES } from "../../utils/enums";
import { isString, isValidInput } from "../../utils/validations";
import ViewDocModal from "../../Modals/viewDocModal";
import usePermission from "../../hooks/usePermission";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AddTeam = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [dialCode, setDialCode] = useState("+971");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [openDocView, setOpenDocView] = useState(false);
  const [docViewImage, setDocViewImage] = useState("");
  const [fileName, setFileName] = useState<string>("");
  const [getCatogery] = useLazyGetCategoryQuery();
  const [page, setPage] = useState(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [catogery, setCatogery] = useState<any>([""]);
  const [buttonType, setButtonType] = useState("");
  const [userId, setUserId] = useState("");
  const [addCustomer] = useAddCustomerMutation();
  const [updateCustomer] = useUpdateCustomerMutation();
  const [getCustomerById] = useLazyGetCustomerByIdQuery();
  const [teamDetail, setTeamDetail] = useState<Customer | null>(null);
  const [proofDocs, setProofDocs] = useState<string[]>([]);

  usePermission({ label: "Manage Maintenance Team", page_permission: "isAdd" });

  const [selectField1, setSelectField1] = React.useState("default");
  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectField1(event.target.value as string);
  };
  const handleNextTab = () => {
    setValueTabs((prevIndex) => prevIndex + 1); // Move to the next tab
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    // if (Array.from(files || []).length > 20) {
    //   errorToast("Max limit is upto 20 images");
    //   event.target.value = "";
    //   return;
    // }

    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
    ];
    const invalidFiles = Array.from(files || []).filter(
      (file) => !allowedTypes.includes(file.type)
    );
    if (invalidFiles.length > 0) {
      showError("Inavlid  type");
      event.target.value = "";
      return;
    }
    const resArray = await Promise.all(
      Array.from(files || []).map(async (file) => {
        if (allowedTypes.includes(file.type)) {
          return UploadMedia(file);
        }
      })
    );

    resArray.map((res) => {
      if (res?.statusCode === 200) {
        setProofDocs((prevImages) => [...prevImages, res?.data]);

        event.target.value = "";
      } else {
        event.target.value = "";
      }
    });
  };

  // const handleImageUpload = async (
  //   event: React.ChangeEvent<HTMLInputElement>,
  //   type: string
  // ) => {
  //   const files = event.target.files;

  //   const file = files?.length ? files[0] : null;

  //   if (!file) {
  //     return;
  //   }

  //   const imageUrl = (await UploadMedia(file)) as any;

  //   if (imageUrl?.data) {
  //     formik.setFieldValue(type, imageUrl?.data);
  //   }
  // };

  const handleChangePhone = (phone: any, country: any) => {
    setPhone(phone?.replace(country.dialCode, ""));
    setDialCode(country?.dialCode);
  };

  let totalPages = Math.ceil(totalCount / 10);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: teamDetail?.fullName || "",
      email: teamDetail?.email || "",
      phone: "",
      professionId:
        teamDetail?.professionId?.map((item) => item?._id) || ([] as string[]),
      profDocFrontImg: teamDetail?.profDocFrontImg || "",
      profDocBackImg: teamDetail?.profDocBackImg || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .required("Email is required!")
        .email("Invalid email address"),

      professionId: Yup.array().min(1, "At least one profession is required"),
    }),
    onSubmit: async (values: any) => {
      if (phone.length < 8) return;
      formik.setSubmitting(true);

      let body = {
        fullName: values?.name || "",
        phone: phone || "",
        email: values?.email || "",
        professionId: values.professionId || [],
        countryCode: (dialCode.includes("+") ? "" : "+") + dialCode,
        professionalDocs: proofDocs || [],
        ...(id ? { userId: id } : {}),
        ...(!id ? { role: ROLES.MAINTAINER } : {}),
      };

      try {
        let response;
        if (id) {
          // If ID exists, update customer
          response = await updateCustomer(body).unwrap();
        } else {
          // Else, add customer
          response = await addCustomer(body).unwrap();
        }
        if (response?.statusCode === 200) {
          setUserId(response?.data?._id || "");
          showToast(
            id
              ? "Management team updated successfully"
              : "Management team added successfully"
          );
          // setValueTabs((prevIndex) => prevIndex + 1);
          if (buttonType) {
            navigate(-1);
          } else {
            setValueTabs((prevIndex) => prevIndex + 1);
          }
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.log(error);
      }
    },
  });

  const handleRemoveFile = (e: React.MouseEvent, fileUrl: string) => {
    e.stopPropagation();
    setProofDocs((prevDocs) => prevDocs.filter((doc) => doc !== fileUrl));
  };

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await getCustomerById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setTeamDetail(response?.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const getCatogeryList = async () => {
    try {
      const response = await getCatogery({
        page,
        search: debouncedSearchTerm,
        limit: 10,
      }).unwrap();
      if (response?.statusCode === 200) {
        setCatogery(response?.data?.list);
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || "Catogery Fetch Failed");
    }
  };

  useEffect(() => {
    if (teamDetail?.phone) {
      setPhone(teamDetail?.phone || "");
      setDialCode(teamDetail?.countryCode || "");
      setProofDocs(teamDetail?.professionalDocs || []);
    }
  }, [teamDetail]);

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  useEffect(() => {
    getCatogeryList();
  }, [debouncedSearchTerm, page]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Add Maintenance Team</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-maintenance-team")}>
            Manage Maintenance Team
          </span>{" "}
          -{id ? "Update" : "Add"} Maintenance Team
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="General Details" {...a11yProps(0)} />
              {/* <Tab label="Bank Details" {...a11yProps(1)} /> */}
              <Tab label="Documents" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <CustomTabPanel value={valueTabs} index={0}>
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="cards">
            <div className="section_title">
              <h2>Personal Details</h2>
            </div>
            <div className="gap_p">
              <div className="control_group w_50">
                <label>Name</label>
                <TextField
                  placeholder="Enter Name"
                  variant="outlined"
                  className="text_field"
                  fullWidth
                  hiddenLabel
                  name="name"
                  id="name"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.name}
                  onChange={(val) => {
                    if (
                      isValidInput(val.target.value) &&
                      isString(val.target.value)
                    ) {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.name && formik.errors.name}
                />
              </div>
              <div className="control_group w_50">
                <label>Email Id</label>
                <TextField
                  placeholder="Enter Email Id"
                  hiddenLabel
                  fullWidth
                  className="text_field"
                  name="email"
                  id="email"
                  inputProps={{ maxLength: 80 }}
                  value={formik.values.email}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <PhoneInput
                  enableSearch
                  value={dialCode + phone}
                  country={"uae"}
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%" }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                />
                {!phone && error ? (
                  <h6 className="err_msg">This field is required</h6>
                ) : (
                  ""
                )}
                {phone.length >= 1 && phone.length < 8 && error ? (
                  <h6 className="err_msg">Please enter a valid phone number</h6>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          {/* <div className="docView docview1">
            <a
              onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior
                window.open("https://example.com", "_blank"); // Ensure URL is correct
              }}
              href="https://example.com" // Backup in case JavaScript is disabled
            >
              <figure>
                <img src="/static/images/pdf.png" alt="PDF Icon" />
              </figure>
              <p>View</p>
            </a>
          </div> */}
          <div className="cards">
            <div className="section_title">
              <h2>Profession/Skills</h2>
            </div>
            <div className="gap_p">
              <div className="control_group w_33">
                <label>Profession</label>
                <Select
                  fullWidth
                  labelId="professionId"
                  id="professionId"
                  multiple
                  value={
                    formik.values.professionId?.length
                      ? formik.values.professionId
                      : ["Select Skills"]
                  }
                  onChange={(event: SelectChangeEvent<string[]>) => {
                    formik.setFieldValue(
                      "professionId",
                      //@ts-ignore
                      event.target.value?.filter(
                        (data: any) => data !== "Select Skills"
                      )
                    );
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        // width: 2,
                        maxHeight: 200,
                        padding: "10px 0",
                        // marginBottom: "5px",
                      },
                    },
                  }}
                >
                  <MenuItem disabled value="Select Skills">
                    Select Skills
                  </MenuItem>
                  {Array.isArray(catogery) &&
                    catogery?.map((category: any, index: any) => (
                      <MenuItem
                        key={index}
                        value={category._id}
                        style={{ padding: "10px 20px" }}
                      >
                        {category.categoryName}
                      </MenuItem>
                    ))}
                </Select>

                {!formik.values.professionId?.length && error ? (
                  <h6 className="err_msg">This field is required</h6>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className="cards">
            <div className="section_title">
              <h2>Proof of experience</h2>
            </div>
            <div className="gap_p">
              <div className="control_group w_100">
                <label>Upload Proof Docs and Image</label>

                <div className="docFlex">
                  <div className="childDiv">
                    <label
                      className="upload_image no_radius v2"
                      htmlFor="icon-button-file"
                    >
                      <Input
                        sx={{ display: "none" }}
                        id="icon-button-file"
                        type="file"
                        inputProps={{
                          accept: "image/png, image/jpeg, application/pdf",
                          multiple: true,
                        }}
                        onChange={(e: any) => {
                          handleImageUpload(e);
                          e.target.value = null;
                        }}
                      />

                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt="icon"
                          />
                          <span className="upload_img_icon">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt="icon"
                            />
                          </span>
                        </figure>
                      </span>
                    </label>
                  </div>

                  {/* <div className="docView docview1">
                    <a
                      onClick={() => window.open("klsfsld")}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <figure>
                        <img src="/static/images/pdf.png" alt="PDF Icon" />
                      </figure>
                      <p>View</p>
                      <CloseIcon
                        onClick={() => handleRemoveFile("klsfsld")}
                        style={{ cursor: "pointer" }}
                      />
                    </a>
                  </div> */}

                  {proofDocs?.length > 0
                    ? proofDocs.map((item, index) =>
                        item.endsWith(".pdf") ? null : (
                          <div key={index} className="childDiv">
                            <div className="upload_image no_radius v2">
                              <div className="upload_image_holder">
                                <figure>
                                  <CardMedia
                                    component="img"
                                    image={item}
                                    alt="photo"
                                  />
                                </figure>
                                <CloseIcon
                                  onClick={(e) => handleRemoveFile(e, item)}
                                  style={{ cursor: "pointer" }}
                                />
                              </div>
                            </div>
                          </div>
                        )
                      )
                    : null}
                </div>
                <div className="abc">
                  {proofDocs?.length > 0
                    ? proofDocs.map((item, index) =>
                        item.endsWith(".pdf") ? (
                          <div
                            key={index}
                            className="childDiv w_100"
                            style={{ width: "50%" }}
                          >
                            <div className="docView docview1">
                              <a
                                onClick={() => window.open(item)}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <figure>
                                  <img
                                    src="/static/images/pdf.png"
                                    alt="PDF Icon"
                                  />
                                </figure>
                                <p style={{ cursor: "pointer" }}>View</p>
                                <CloseIcon
                                  onClick={(e) => handleRemoveFile(e, item)}
                                  style={{ cursor: "pointer" }}
                                />
                              </a>
                            </div>
                          </div>
                        ) : null
                      )
                    : null}
                </div>
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => setError(true)}
                type="submit"
              >
                Next
              </Button>

              {id ? (
                <Button
                  className="btn btn_primary"
                  onClick={() => {
                    setButtonType("Submit");
                    setError(true);
                  }}
                  type="submit"
                >
                  Submit
                </Button>
              ) : null}
            </div>
          </div>
        </form>
      </CustomTabPanel>
      {/* <CustomTabPanel value={valueTabs} index={1}>
        <form className="form">
          <div className="cards">
            <div className="gap_p">
              <div className="control_group w_33">
                <label>Bank Name</label>
                <TextField
                  placeholder="Enter Bank Name"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
              <div className="control_group w_33">
                <label>Account Holder’s Name</label>
                <TextField
                  placeholder="Enter Account Holder’s Name"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
              <div className="control_group w_33">
                <label>Account Number</label>
                <TextField
                  placeholder="Enter Account Number"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
              <div className="control_group w_33">
                <label>IFSC Code</label>
                <TextField
                  placeholder="Enter IFSC Code"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
              <div className="control_group w_33">
                <label>Branch Name</label>
                <TextField
                  placeholder="Enter Branch Name"
                  hiddenLabel
                  fullWidth
                ></TextField>
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary" onClick={handleNextTab}>
                Next
              </Button>
            </div>
          </div>
        </form>
      </CustomTabPanel> */}
      {/*document*/}
      <CustomTabPanel value={valueTabs} index={1}>
        <CompanyDocumentation
          userId={userId || id || ""}
          setValueTabs={setValueTabs}
          mode="Maintainance"
          setOpenDocView={setOpenDocView}
          setDocViewImage={setDocViewImage}
        />
      </CustomTabPanel>
      <ViewDocModal
        open={openDocView}
        onClose={() => setOpenDocView(false)}
        imageUrl={docViewImage || ""}
      />
    </MainContainer>
  );
};

export default AddTeam;
